
import { Component, Prop, Vue } from "vue-property-decorator";

const CLASS = "sidebar-upgrade-badge";

const ICON = "CrownFilled";
const LABEL = "Upgrade to Premium";

const PRICING_ROUTE = "Pricing";

@Component
export default class AppSidebarUpgradeBadge extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly collapsed?: boolean;

  ICON = ICON;
  LABEL = LABEL;

  get classes() {
    const { collapsed } = this;
    return {
      [`${CLASS}_collapsed`]: collapsed,
    };
  }

  async goToPricing() {
    try {
      await this.$router.push({
        name: PRICING_ROUTE,
      });
    } catch {
      return;
    }
  }
}
